<div class="w-full px-4 py-3">
  <!-- Header Section -->
  <div class="mb-4 bg-blure-light rounded border-2 border-blue-200 p-3">
    <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-2">
      <header class="mb-1">
        <h2 class="text-lg font-semibold">
          {{
            schemeType === "makeIII" || schemeType === "makeII"
              ? "Selection of Proposal"
              : "Initiation of Proposal"
          }}
        </h2>
        <div class="flex flex-row items-start gap-2 mt-1">
          <span class="text-blue-600 font-medium text-base">[{{ payload?.proposal_name }}]</span>
          <span
            class="inline-block rounded px-3 py-1 text-xs font-semibold text-white"
            [ngClass]="{
              'bg-gray-500': stepDetails?.step_status == 0,
              'bg-green-500': stepDetails?.step_status == 'approved',
              'bg-yellow-500': stepDetails?.step_status == 'recommended',
              'bg-blue-500': stepDetails?.step_status == 'initiated'
            }"
          >
            {{
              stepDetails?.step_status == 0
                ? "PENDING"
                : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </header>
      <!-- Actions -->
      <div class="flex items-center mt-4 md:mt-0">
        <ng-container *ngIf="stepDetails?.can_edit">
          <button 
            class="bg-blue-600 hover:bg-blue-700 text-white flex items-center gap-2 px-4 py-2 rounded disabled:opacity-60 transition-colors"
            (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="proposalForm?.invalid"
            type="button"
          >
            <i class="pi pi-save"></i>
            <span>Save/Forward/Route Config</span>
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- Need Generation From Expansion Panel -->
  <div *ngIf="needGenData?.need_generation?.length > 0" class="mb-4">
    <div 
      class="rounded-lg overflow-hidden border border-blue-200 shadow bg-gradient-to-tr from-blue-50 to-blue-100"
    >
      <button 
        type="button"
        (click)="expandedSections['needGenFrom'] = !expandedSections['needGenFrom']"
        class="w-full flex items-center justify-between px-5 py-3 transition-colors duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400 group"
        [attr.aria-expanded]="expandedSections['needGenFrom']"
        [attr.aria-controls]="'needGenFrom-panel'"
      >
        <span class="flex items-center gap-3">
          <span class="text-base font-semibold text-blue-800">Need Generation From</span>
          <span 
            class="inline-block text-xs bg-blue-200 text-blue-600 rounded-full px-2 py-0.5 font-medium tracking-wide"
            *ngIf="needGenData?.need_generation?.length">
            {{ needGenData?.need_generation?.length }}
          </span>
        </span>
        <span 
          class="transition-all transform duration-200 bg-blue-100 rounded-full p-1.5 group-hover:bg-blue-200"
        >
          <i class="pi"
            [ngClass]="{
              'pi-chevron-down': expandedSections['needGenFrom'],
              'pi-chevron-right': !expandedSections['needGenFrom']
            }"
          ></i>
        </span>
      </button>
      <div *ngIf="expandedSections['needGenFrom']" id="needGenFrom-panel"
        class="bg-white border-t border-blue-100 px-3 py-2 animate-fadeIn"
        style="animation: fadeIn .3s;">
        <app-needfrom [data]="needGenData?.need_generation[0]"></app-needfrom>
      </div>
    </div>
  </div>

  <!-- Uploaded Document Section -->
  <div>
    <ng-container *ngIf="stepDetails.code === 'R-IP'; else elseBlock">
      <app-upload-document
        [title]="'Uploaded Document'"
        [isEditable]="stepDetails?.can_edit"
        [proposal_step]="stepDetails?.id-3"
      ></app-upload-document>
    </ng-container>
    <ng-template #elseBlock>
      <app-upload-document
        [title]="'Uploaded Document'"
        [isEditable]="stepDetails?.can_edit"
        [proposal_step]="stepDetails?.id-3"
      ></app-upload-document>
    </ng-template>
  </div>
</div>

<style>
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-0.25rem);}
  to { opacity: 1; transform: none;}
}
.animate-fadeIn {
  animation: fadeIn .3s;
}
</style>
